import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { ShoppingBagType } from 'types/store'

type Props = {
  shoppingBag: ShoppingBagType
}

const ShoppingBagOptionCard: FC<Props> = (props) => {
  const { shoppingBag } = props
  return (
    <div className={styles.shoppingBag}>
      <span className={`${text.font_bold} ${text.font_medium}`}>{shoppingBag.name}</span>
      <span className={`${text.font_bold} ${text.font_medium}`}>{shoppingBag.price}円</span>
    </div>
  )
}

export default ShoppingBagOptionCard
